import { render, staticRenderFns } from "./student.payment.vue?vue&type=template&id=23082f5e"
import script from "./student.payment.vue?vue&type=script&lang=js"
export * from "./student.payment.vue?vue&type=script&lang=js"
import style0 from "./student.payment.vue?vue&type=style&index=0&id=23082f5e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports